import { WebAuth } from "./auth";
import { WebDocsLinks } from "./docs-links";

customElements.define("cyvl-docs-links", WebDocsLinks);
customElements.define("cyvl-auth", WebAuth);
